import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import "./LoginButton.scss";

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();
  const handleLogin = async () => {
    await loginWithRedirect();
  };
  
  const loginStyle = {fontFamily: "Space Mono", fontSize: "100", backgroundColor: "#5fc3ac", color: "white", paddingLeft: "50px", paddingRight: "50px"}
  const txtStyle = {alignItems: "baseline"}

  return (
    <button className="button login-btn" style={loginStyle} onClick={handleLogin}>
      <span className="icon is-small">
        <i className="fas fa-user"></i>
      </span>
      <span style={txtStyle}>Log in</span>    
    </button>
  );
};

export default LoginButton;